class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    // const swiperNotice = swiperFun();
    // swiperNotice.init();
    
    // this.getTotalAmount();
    // 免费礼物数字框隐藏
    $('.quantity__input[data-quantity-variant-id=40987319337093]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40987319206021]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40987319140485]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40992992166021]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997164777605]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997168840837]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997170479237]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41012071202949]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41055579504773]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41055579537541]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41057197097093]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41077611856005]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41077833662597]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087061753989]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087096455301]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087095636101]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107108298885]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107108954245]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107109544069]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41163590369413]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40846468481157]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186570338437]').prop('readonly', 'readonly').val("1").parent().hide();
    
    $('.quantity__input[data-quantity-variant-id=41186560966789]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186561392773]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186561491077]').prop('readonly', 'readonly').val("1").parent().hide();

    $('.quantity__input[data-quantity-variant-id=41243412922501]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41424862937221]').prop('readonly', 'readonly').val("1").parent().hide();

    //万圣节
    $('.quantity__input[data-quantity-variant-id=41369463062661]').prop('readonly', 'readonly').val("1").parent().hide();

    //手机壳 系列 normal
    $('.cart-remove-button[data-variant-id=41438785142917]').hide();
    $('.quantity__input[data-quantity-variant-id=41438785142917]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41438785142917]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41438785142917]').attr('disabled',true);

    //手机壳 系列 apple
    $('.cart-remove-button[data-variant-id=41314691711109]').hide();
    $('.quantity__input[data-quantity-variant-id=41314691711109]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41314691711109]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41314691711109]').attr('disabled',true);

    //手机壳 系列 android
    $('.cart-remove-button[data-variant-id=41438779211909]').hide();
    $('.quantity__input[data-quantity-variant-id=41438779211909]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41438779211909]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41438779211909]').attr('disabled',true);

    // 杯子
    $('.cart-remove-button[data-variant-id=41325946699909]').hide();
    $('.quantity__input[data-quantity-variant-id=41325946699909]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41325946699909]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41325946699909]').attr('disabled',true);

    // 返校季    
    $('.quantity__input[data-quantity-variant-id=41299120619653]').prop('readonly', 'readonly').val("1").parent().hide();

    //二代自动热压机系列赠品 41385825534085 
    $('.cart-remove-button[data-variant-id=41385825534085]').hide();
    $('.quantity__input[data-quantity-variant-id=41385825534085]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41385825534085]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41385825534085]').attr('disabled',true);
    
    //机械帽子热压机 41386142990469 
    $('.cart-remove-button[data-variant-id=41386142990469]').hide();
    $('.quantity__input[data-quantity-variant-id=41386142990469]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41386142990469]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41386142990469]').attr('disabled',true);

    //绘画机 41385811837061 
    $('.cart-remove-button[data-variant-id=41385811837061]').hide();
    $('.quantity__input[data-quantity-variant-id=41385811837061]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41385811837061]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41385811837061]').attr('disabled',true);

    // 为所有触发产品ID添加quantity input控制
    if (window.giftVariantIds && Array.isArray(window.giftVariantIds)) {
      window.giftVariantIds.forEach(variantId => {
        $('.quantity__input[data-quantity-variant-id=' + variantId + ']')
          .prop('readonly', 'readonly')
          .val("1")
          .parent()
          .hide();
      });
    }
        // 黑五 40843114053765
    // $('.cart-remove-button[data-variant-id=40843114053765]').hide();
    // $('.quantity__input[data-quantity-variant-id=40843114053765]').prev().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=40843114053765]').next().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=40843114053765]').attr('disabled',true);

    // // 黑五 新赠品1 41424862937221
    // $('.cart-remove-button[data-variant-id=41424862937221]').hide();
    // $('.quantity__input[data-quantity-variant-id=41424862937221]').prev().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=41424862937221]').next().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=41424862937221]').attr('disabled',true);

    // // 黑五 新赠品2 41424862969989
    // $('.cart-remove-button[data-variant-id=41424862969989]').hide();
    // $('.quantity__input[data-quantity-variant-id=41424862969989]').prev().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=41424862969989]').next().attr('disabled',true).css('cursor','not-allowed;');
    // $('.quantity__input[data-quantity-variant-id=41424862969989]').attr('disabled',true);

     var product_id = ['7076595269765','7076595433605','7076595335301','7079023968389','7079026360453','7079027310725','7096140824709','7096524865669','7109015961733','7109037064325','7109036671109','7115754012805','7115754602629','7115755225221'
                      ,'7135729451141','7199888146565'];
     var gift_id = ['7078331973765']
     var superGiftSyp_id = ['7084151636101']
     var discountCardId = ['7106034696325']
     var discountCardIdAllYear = ['7106067038341']
     var loklikMachine = ['7142754779269']
     var newGift = ['7161495060613']
     var cartContents = fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        var cartArr = [];
        var cartList = data.items;  
        // const GIFT_A_ID = 41186560966789;  //  $229
        // const GIFT_B_ID = 41186561392773;  // $339
        // const GIFT_C_ID = 41186561491077; // $569
        // const GIFT_D_ID = 41299120619653; // $569

        // let hasGiftA = false;
        // let hasGiftB = false;
        // let hasGiftC = false;
        // let hasGiftD = false;
        
         const syncConfigs = [
          {
              mainId: 41325946699909, // Cup_ID A300_ID
              variantIds: [41390529773701,41390529806469,41390529839237,41390529872005,41385775857797,41385773957253,41385773760645,41385774153861,41387028971653,41385792962693,41385802334341,41385809313925,41389942669445,41389942702213,41385793978501,41404369666181,41386174414981,41389013500037,41389013565573,41386234183813,41386230907013,41386238607493,41386238869637,41386239885445,41386241523845,41392515678341,41392515711109,41392515743877,41385773695109,41385767010437,41417263677573,41417254928517,41417263284357,41417151840389,41417152036997,41417152135301,41385863512197,41385863741573,41385864626309,41386142400645,41386188308613,41386188341381,41386148987013,41386150985861,41386151411845,41392610312325,41392610345093,41392610377861,41401504235653, 41401504268421,41385813475461,41385809248389,41390765965445,41390765998213,41389012779141,41389005176965],
              totalQuantity: 0,
              hasItem: false,
              currentQuantity: 0
          },{
              mainId: 41438779211909, // phone_cases_Apple
              variantIds: [41390531149957,41390531182725,41390531215493],
              totalQuantity: 0,
              hasItem: false,
              currentQuantity: 0
          },{
              mainId: 41438780817541, // phone_cases_Android
              variantIds: [41390531248261,41390531281029,41390531313797],
              totalQuantity: 0,
              hasItem: false,
              currentQuantity: 0
          },{
              mainId: 41438785142917, // phone_cases_normal
              variantIds: [41385569583237,41385588719749,41385598746757,41385609396357,41385616277637,41385616408709,41385633742981,41385667756165,41404369895557],
              totalQuantity: 0,
              hasItem: false,
              currentQuantity: 0
          }
        ]
        const testConfigs = [
          {
            triggerProductIds:  window.triggerProductIds || [],
            totalQuantity: 0,
            hasPopped: localStorage.getItem('giftPopupHasPopped') === 'true' || 'false'
          }
        ];
        // 初始化标志变量
        let hasTriggerProduct = false;
        let hasGiftProduct = false;
        let triggerProductsInCart = [];
        if (cartList.length > 0) {
          cartList.forEach((item) => {
            cartArr.push(item.product_id);
            // if (item.id === GIFT_A_ID) hasGiftA = true;
            // if (item.id === GIFT_B_ID) hasGiftB = true;
            // if (item.id === GIFT_C_ID) hasGiftC = true;
            // if (item.id === GIFT_D_ID) hasGiftD = true;
            syncConfigs.forEach(config => {
              if (config.variantIds.includes(item.id)) {
                config.totalQuantity += item.quantity || 0;
              }
              if (item.id === config.mainId) {
                config.hasItem = true;
                config.currentQuantity = item.quantity;
              }
            });
            // testConfigs 逻辑：检查触发产品和赠品
            testConfigs.forEach(config => {
              // 检查是否是触发产品
              if (config.triggerProductIds.includes(item.id)) {
                hasTriggerProduct = true;
                triggerProductsInCart.push(item.id);
                config.totalQuantity += item.quantity || 0;
              }
              
              // 检查是否包含赠品
              if (window.giftVariantIds && window.giftVariantIds.includes(item.id)) {
                hasGiftProduct = true;
              }
            });
          });
        }
          // 合并删除操作对象
          const delOperations = {};
          // 合并添加操作数组
          const addItems = [];

          // 判断是否需要弹出赠品弹窗
          testConfigs.forEach(config => {
            console.log(config.hasPopped,'config.hasPopped',config.totalQuantity,'config.totalQuantity',config.totalQuantity,'config.totalQuantity')
                  
            // 从 localStorage 获取上一次的 totalQuantity
            const lastTotalQuantity = parseInt(localStorage.getItem('lastTotalQuantity')) || 0;
            
            // 检查 totalQuantity 是否增加
            const quantityIncreased = config.totalQuantity > lastTotalQuantity;
            
            if (quantityIncreased) {
              // 如果 totalQuantity 增加了，重置 hasPopped 为 false
              config.hasPopped = 'false';
            }
            
            if (hasTriggerProduct && !hasGiftProduct && config.hasPopped == 'false') {
              $('#gift-popup').show();
              // 弹窗显示后，设置 hasPopped 为 true
              config.hasPopped = 'true';
            }
            else if  (hasTriggerProduct && hasGiftProduct ){
              $('#gift-popup').hide();
            }
            else if (!hasTriggerProduct) {
              // 没有触发产品，清除赠品
              this.removeGiftItems();
              $('#gift-popup').hide();
              // 重置所有状态
              config.hasPopped = 'false';
              config.lastTotalQuantity = 0;
            }
            // 更新存储的 totalQuantity
            localStorage.setItem('lastTotalQuantity', config.totalQuantity.toString());
            // 其他情况（有触发产品且有赠品，或没有触发产品）不弹窗
          });
        
          // 第一阶段：处理赠品逻辑
          // if (hasGiftA || hasGiftB || hasGiftC || hasGiftD) {
          //   Object.assign(delOperations, {
          //     [GIFT_D_ID]: 0
          //   });
          // } 
         // 处理每种商品的同步逻辑
        syncConfigs.forEach(config => {
          const { mainId, totalQuantity, hasItem, currentQuantity } = config;
          
          if (totalQuantity >= 0) {
            const currentQty = hasItem ? currentQuantity : 0;
            
            if (totalQuantity > currentQty) {
              // 需要添加商品
              addItems.push({
                id: mainId,
                quantity: totalQuantity - currentQty
              });
            } else if (totalQuantity !== 0 && totalQuantity < currentQty) {
              // 需要减少商品数量
              delOperations[mainId] = currentQty - totalQuantity;
            } else if (totalQuantity === 0 && hasItem) {
              // 需要完全移除商品
              delOperations[mainId] = 0;
            }
          }
        });
      
        // // 批量执行操作
        if (Object.keys(delOperations).length > 0) {
          this.clearcart(delOperations);
        }
        if (addItems.length > 0) {
          this.addCart({ items: addItems });
        }

        // 一些购物车的处理
        var finalTotalPrice = data.total_price / 100;
        if(data.item_count > 0){
         $('.cart-count-amount>span:nth-child(1)').text(data.item_count)
        }else{
          $('.cart-count-amount').hide();
        }
        $('.drawer__heading>.total').text(`${data.item_count} items`)
        if(data.original_total_price){
          var originalTotalPrice = data.original_total_price / 100;
          $('s[data-cart-total]').children().text('$'+originalTotalPrice);
        }
        $('.total_value>span').text('$'+finalTotalPrice)
        $('#item_count').text(data.item_count+' items')
        if(finalTotalPrice == 0){
          $('.cart__checkout-button button').attr('disabled','true')
        }
        const commonElements = product_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const giftElements = gift_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const sypElements = superGiftSyp_id.filter(item => cartArr.some(otherItem => otherItem == item));
        const discountElements = discountCardId.filter(item => cartArr.some(otherItem => otherItem == item));
        const discountAllYearElements = discountCardIdAllYear.filter(item => cartArr.some(otherItem => otherItem == item));
        const loklikMachineElements = loklikMachine.filter(item => cartArr.some(otherItem => otherItem == item));
        const newGiftElements = newGift.filter(item => cartArr.some(otherItem => otherItem == item));
        
        if(commonElements && commonElements.length > 0){
           $('.auto2-free-gift .product-form__submit').attr('disabled',true);
           $("#auto2-free-gift-tips").show();
            $('#updates_7076595269765').hide();
            $('#updates_7076595433605').hide();
            $('#updates_7076595335301').hide();
            $('#updates_7079023968389').hide();
            $('#updates_7079026360453').hide();
            $('#updates_7079027310725').hide();
            $('#updates_7096140824709').hide();
            $('#updates_7135729451141').hide();
            $('#updates_7199888146565').attr('disabled', true);
            $('.product div[data-id="7199888146565"] .product-form__off').text('Free gift successfully added. Limited to one per order.').show();
            $('.product div[data-id="7096140824709"] #reset_button,.product div[data-id="7135729451141"] #reset_button').show().attr('disabled', true);
            $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').show();
            $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').text('Max 1 free gift or deposit per order.');
              setTimeout(function(){
                 $('#cart_recom1_7096140824709.product-form__submit,#updates_7096140824709.product-form__submit,#cart_recom1_7076595269765.product-form__submit,#cart_recom1_7076595433605.product-form__submit,#cart_recom1_7076595335301.product-form__submit,#cart_recom1_7079023968389.product-form__submit,#cart_recom1_7079026360453.product-form__submit,#cart_recom1_7079027310725.product-form__submit,#cart_recom1_7096524865669.product-form__submit,#cart_recom1_7109015961733.product-form__submit,#cart_recom1_7109037064325.product-form__submit,#cart_recom1_7109036671109.product-form__submit,#cart_recom1_7135729451141.product-form__submit').attr('disabled', true);
              },1000);
        }else{
           $('.auto2-free-gift .product-form__submit').attr('disabled',false);
           $('.auto2-free-gift .product-form__submit').children('.t').each(function(){
           if($(this).text().indexOf('Sold out') != -1){  
             $(this).parent('.product-form__submit').attr('disabled',true);
            }
          })
           $("#auto2-free-gift-tips").hide();
            $('#updates_7076595269765').show();
            $('#updates_7076595433605').show();
            $('#updates_7076595335301').show();
            $('#updates_7079023968389').show();
            $('#updates_7079026360453').show();
            $('#updates_7079027310725').show();
            $('#updates_7096140824709').show();
            $('#updates_7135729451141').show().attr('disabled', false);
            $('#updates_7199888146565').attr('disabled', false);
            $('.product div[data-id="7199888146565"] .product-form__off').hide();
            $('.product div[data-id="7096140824709"] #reset_button,.product div[data-id="7135729451141"] #reset_button').hide().attr('disabled', false);
            $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').hide();
              setTimeout(function(){
                 $('#cart_recom1_7096140824709.product-form__submit,#updates_7096140824709.product-form__submit,#cart_recom1_7076595269765.product-form__submit,#cart_recom1_7076595433605.product-form__submit,#cart_recom1_7076595335301.product-form__submit,#cart_recom1_7079023968389.product-form__submit,#cart_recom1_7079026360453.product-form__submit,#cart_recom1_7079027310725.product-form__submit,#cart_recom1_7096524865669.product-form__submit,#cart_recom1_7109015961733.product-form__submit,#cart_recom1_7109037064325.product-form__submit,#cart_recom1_7109036671109.product-form__submit,#cart_recom1_7135729451141.product-form__submit').attr('disabled', false);
              },1000);
        }
        if(giftElements && giftElements.length > 0){
          $('.auto2-form-addtocart .product-form__submit').attr('disabled', true);
          $('.auto2-form-dialog-model-tips').show();
        }else{
          $('.auto2-form-addtocart .product-form__submit').attr('disabled', false);
          $('.auto2-form-dialog-model-tips').hide();
        }
        if(sypElements && sypElements.length > 0){
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',true);
           $(".auto2-claim-now-tips").show();
        }else{
           $('.auto2-dialog-addcart .product-form__submit').attr('disabled',false);
           $(".auto2-claim-now-tips").hide();
        }
        if(discountElements  && discountElements.length > 0){
            $('.new-year-bundle #campaign_7106034696325').attr('disabled',true);
            $('#updates_7106034696325').hide();
            $('.product div[data-id="7106034696325"] #reset_button').show().attr('disabled', true);
            $('.product div[data-id="7106034696325"] .product-form__off').show();
            $('.product div[data-id="7106034696325"] .product-form__off').text('* Already have one in your cart');
              setTimeout(function(){
                 $('#cart_recom1_7106034696325.product-form__submit,#updates_7106034696325.product-form__submit').attr('disabled', true);
              },1000);
        }else{
            $('.new-year-bundle #campaign_7106034696325').attr('disabled',false);
            $('#updates_7106034696325').show();
            $('.product div[data-id="7106034696325"] #reset_button').hide().attr('disabled', false);
            $('.product div[data-id="7106034696325"] .product-form__off').hide();
              setTimeout(function(){
                 $('#cart_recom1_7106034696325.product-form__submit,#updates_7106034696325.product-form__submit').attr('disabled', false);
              },1000);
        }
        
        if(discountAllYearElements  && discountAllYearElements.length > 0){
         $('.new-year-bundle #campaign_7106067038341').attr('disabled',true);
          $('#updates_7106067038341').hide();
          $('.product div[data-id="7106067038341"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7106067038341"] .product-form__off').show();
          $('.product div[data-id="7106067038341"] .product-form__off').text('* Already have one in your cart');
            setTimeout(function(){
               $('#cart_recom1_7106067038341.product-form__submit,#updates_7106067038341.product-form__submit').attr('disabled', true);
            },1000);
        }else{
           $('.new-year-bundle #campaign_7106067038341').attr('disabled',false);
            $('#updates_7106067038341').show();
            $('.product div[data-id="7106067038341"] #reset_button').hide().attr('disabled', false);
            $('.product div[data-id="7106067038341"] .product-form__off').hide();
              setTimeout(function(){
                 $('#cart_recom1_7106067038341.product-form__submit,#updates_7106067038341.product-form__submit').attr('disabled', false);
              },1000);
        }
        
      if (loklikMachineElements && loklikMachineElements.length > 0) {
          $('.iengtave-deposite-button .product-form__submit').attr('disabled', true);
          $('.iengtave-deposite-tips').show();
          $('#updates_7049217114245,#updates_7142754779269').hide();
          $('.product div[data-id="7049217114245"] #reset_button.product div[data-id="7142754779269"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7049217114245"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').show();
          $('.product div[data-id="7049217114245"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').text('* Already have one in your cart');
          setTimeout(function () {
              $('#cart_recom1_7049217114245.product-form__submit,#updates_7049217114245.product-form__submit,#cart_recom1_7142754779269.product-form__submit,#updates_7142754779269.product-form__submit').attr('disabled', true);
          }, 1000);
      } else {
          $('.iengtave-deposite-button .product-form__submit').attr('disabled', false);
          $('.iengtave-deposite-tips').hide();
          $('#updates_7049217114245,#updates_7142754779269').show();
          $('.product div[data-id="7049217114245"] #reset_button,.product div[data-id="7142754779269"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7049217114245"] .product-form__off,.product div[data-id="7142754779269"] .product-form__off').hide();
          setTimeout(function () {
              $('#cart_recom1_7049217114245.product-form__submit,#updates_7049217114245.product-form__submit,#cart_recom1_7142754779269.product-form__submit,#updates_7142754779269.product-form__submit').attr('disabled', false);
          }, 1000);
      }
        
      if (newGiftElements && newGiftElements.length > 0) {
          $('#updates_7161495060613').hide();
          $('.product div[data-id="7161495060613"] #reset_button.product div[data-id="7142754779269"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7161495060613"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').show();
          $('.product div[data-id="7161495060613"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').text('* Already have one in your cart');
          setTimeout(function () {
              $('#cart_recom1_7161495060613.product-form__submit,#updates_7161495060613.product-form__submit').attr('disabled', true);
          }, 1000);
      } else {
          $('#updates_7161495060613').show();
          $('.product div[data-id="7161495060613"] #reset_button,.product div[data-id="7142754779269"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7161495060613"] .product-form__off,.product div[data-id="7142754779269"] .product-form__off').hide();
          setTimeout(function () {
              $('#cart_recom1_7161495060613.product-form__submit,#updates_7161495060613.product-form__submit').attr('disabled', false);
          }, 1000);
      }
        return data;
      });
  }
// 添加清除赠品的函数
  removeGiftItems() {
    if (!window.giftVariantIds || !Array.isArray(window.giftVariantIds)) return;
    const giftItemsToRemove = {};
    // 获取购物车当前状态
    fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      cartData.items.forEach(item => {
        if (window.giftVariantIds.includes(item.variant_id)) {
          giftItemsToRemove[item.variant_id] = 0;
        }
      });
      if (Object.keys(giftItemsToRemove).length > 0) {
        console.log('清除赠品:', giftItemsToRemove);
        this.clearcart(giftItemsToRemove);
      }
    });
  }
  clearcart(updates) {
    $('#CartDrawer .drawer__inner').addClass('cart-drawer-loading');
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
    .then((response) => {
      return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
      $('#CartDrawer .drawer__inner').removeClass('cart-drawer-loading');
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
  addCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    })
    .then(response => {
        return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }

  getTotalAmount(){
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json()).then(data => {
      const products = data.items.map(item => ({
          productId: item.product_id,
          amountOfMoney: (item.final_line_price) / 100
        })
      );
      var activityCode = $('.calculated-amount').attr('id')
      var data = {
        'site': 'US_HTVRONT(shopify)',
        'activityCode':activityCode,
        'products': products,
      };
      var RSAdata = {
        version: '1.0.0',
        timestamp: new Date().getTime(),
        project: 'htvRont',
        token: 'f8d045ef1350411894cb9659f6e9dce9',
      };
      var rsaEncryptData = RsaEncrypt(JSON.stringify(RSAdata));
      var jsonData = JSON.stringify(data);
      $.ajax({
        url: 'https://qn.htvront.com/promotion/totalAmount',
        method: 'post',
        data: jsonData,
        contentType: 'application/json',
        headers: {
          Authorization: 'Bearer ' + `${rsaEncryptData}`,
        },
        success: function (res) {
          if (res.code == 200) {
            $('.calculated-amount').show();
            $('.calculated-amount-total-price>b').text(res.data.total);
            var couponAmount;
            if (res.data.nextMoney != -1) {
              if(res.data.couponCode == ''){
                res.data.couponCode = 1;
              }
              if(res.data.nextType == 2){
                couponAmount =  Number(res.data.nextAmount)*100 + '%';
              }else{
                couponAmount = '$' + Math.floor(res.data.nextAmount);
              }
              $(`#calculated-amount-text-${res.data.couponCode}>i`).text(couponAmount);
              $(`#calculated-amount-text-${res.data.couponCode}>b`).text(res.data.nextMoney);
              $(`#calculated-amount-text-${res.data.couponCode}>span`).text(Math.floor(res.data.nextTotalAmount)); 
              $(`#calculated-amount-text-${res.data.couponCode}`).show().siblings().hide();
            } else {
              $('#code-last-text').show().siblings().hide();
            }
            $(`#coupons-bottom-item-${res.data.couponCode}`).show().siblings().hide();
          }
        },
        error: function (xhr, status, error) { },
      });
    });
  };
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Drawer-quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }
    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.name == "note"){
      return
    }
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cartDrawer-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.querySelector('.cart_drawer_totals');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cartDrawer-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        // 总金额变化 进度条变化 start
        /*var totalNumber = Number(parsedState.total_price) / 100;
        var progressBar = document.querySelector('.progress-bar');
        var percentage = (totalNumber / 80) * 100;
        progressBar.style.width = `${percentage}%`;*/
        // 总金额变化 进度条变化 end

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    //console.log(html,selector)
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
